import { Table, TableColumnsType } from 'antd';
import { FC } from 'react';
import { ISourcesTableData, reportsSelect } from '@entities/reports';
import { useSelector } from 'react-redux';
import * as S from './styles';
import { createSourcesColumns } from '../createSourcesColumns';
import { formatNumberWithDot } from '@utils/functions/formatNumberWithDot';

export const SourcesTable: FC = () => {
    const { sources, loading } = useSelector(reportsSelect);

    const columns: TableColumnsType<ISourcesTableData> = createSourcesColumns({
        columns: sources?.columns,
    });

    const summary = () => {
        const totals: Record<string, number> | undefined = sources?.totals;

        if (!totals) {
            return null;
        }

        return (
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                    <strong>Итого</strong>
                </Table.Summary.Cell>
                {Object.keys(totals).map((item, index) => {
                    if (item === 'Источник') return null;

                    return (
                        <Table.Summary.Cell key={item} index={index}>
                            <S.StyledSum>
                                {index > 2
                                    ? formatNumberWithDot(totals[item])
                                    : totals[item]}
                            </S.StyledSum>
                        </Table.Summary.Cell>
                    );
                })}
            </Table.Summary.Row>
        );
    };

    return (
        <S.StyledTable>
            <Table
                pagination={false}
                {...(sources?.table?.length ? { scroll: { x: 700 } } : {})}
                dataSource={sources?.table}
                loading={loading === 'loading'}
                columns={columns}
                summary={summary}
                size="small"
            />
        </S.StyledTable>
    );
};
